import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import resourcesToBackend from "i18next-resources-to-backend"
import { DEFAULT_LANGUAGE } from "../helpers/utils/constants"
import { DEBUG } from "./config"

const DETECTION_OPTIONS = {
  order: ["localStorage", "navigator"],
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string) =>
        import(`./locales/${language}/${namespace}.json`),
    ),
  )
  .init({
    debug: DEBUG,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    detection: DETECTION_OPTIONS,
  })

export default i18next
